export const decodeEntityString = (name?: string) => (name ? name.replace(/&trade;/g, '™').replace(/&amp;/g, '&') : '');
